import axiosHttp from "../hooks/intercepter";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getFarms = async () => {
    return await axiosHttp.get(`${BASE_URL}/farms`);
}

export const addFarm = async (payload) => {
    return await axiosHttp.post(`${BASE_URL}/farms`, payload);
}

export const updateFarm = async (payload) => {
    return await axiosHttp.put(`${BASE_URL}/farms/${payload._id}`, payload);
}

export const deleteFarm = async (payload) => {
    return await axiosHttp.delete(`${BASE_URL}/farms/${payload._id}`);
}